import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Menu, MenuItem } from "@mui/material";
import { selectCalculators, loadCalculator, setCurrent } from "../calculators/calculatorsSlice";
import { ArrowDropDown } from "@mui/icons-material";

export const Version = () => {
	const dispatch = useDispatch();
	const view = useSelector(state => state.calculators.view);
	const previousVersions = useSelector(state => selectCalculators(state));
	const selectedIndex = useSelector(state => state.calculators.current);
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const changeVersion = (index) => {
		dispatch(setCurrent(index));
		setAnchorEl(null);
		dispatch(loadCalculator({id: index-1, type: view, name: previousVersions[index-1].name}));
	};

	return (
		!!previousVersions.length ? <>
			<Button endIcon={<ArrowDropDown/>} onClick={handleClick}>{selectedIndex > 0 ? previousVersions[selectedIndex-1].name : "Select Previous Versions"}</Button>
			<Menu
				anchorEl={anchorEl}
				id="account-menu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				disableScrollLock
				PaperProps={{
					elevation: 0,
					sx: {
						overflow: "visible",
						filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
						mt: 1.5,
						"&:before": {
							content: "''",
							display: "block",
							position: "absolute",
							top: 0,
							right: "calc(50% - 5px)",
							width: 10,
							height: 10,
							bgcolor: "background.paper",
							transform: "translateY(-50%) rotate(45deg)",
							zIndex: 0
						},
					},
				}}
				transformOrigin={{ horizontal: "center", vertical: "top" }}
				anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
			>
				{!!previousVersions.length && previousVersions.map(({ name }, key) =>
					<MenuItem key={`version_${view}_${key}`} onClick={() => changeVersion(key + 1)}>
						{name}
					</MenuItem>
				)}
			</Menu>
		</> : null
	);
};
